import { render, staticRenderFns } from "./OfficeInterviewRecorderForm.vue?vue&type=template&id=f805b156&scoped=true&"
import script from "./OfficeInterviewRecorderForm.vue?vue&type=script&lang=js&"
export * from "./OfficeInterviewRecorderForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficeInterviewRecorderForm.vue?vue&type=style&index=0&id=f805b156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805b156",
  null
  
)

/* custom blocks */
import block0 from "./OfficeInterviewRecorderForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./OfficeInterviewRecorderForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VDivider,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
